import { api } from "../api";

export function getEmailsFrequency() {
  return api.get("/api/users/current/settings/emails/options");
}
